import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { Toaster } from 'sonner';
render(<>
    <App data-id="element-316" data-mp="1wbmqzqogm2p9" />
    <Toaster position="top-right" richColors data-id="element-317" data-mp="1wbd080vlbrii" />
  </>, document.getElementById('root'));